import { Category } from '../types';
import { prefixedId } from '../utils/idUtils';

export function createDefaultCategories(): Category[] {
  const categoryId = prefixedId('cat');

  return [
    {
      id: categoryId,
      name: 'Habits',
      color: '#a0a0a0',
      habits: [],
    },
  ];
}
